module.exports = __webpack_public_path__ + "img/banner-step4.387bcce0.png";